<script setup lang="ts" generic="TPresenter extends (EditPresenter | ListPresenter)">
import Translator from "@/utils/common/Translator.ts";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import ActionHandler from "@/utils/moreMenu/ActionHandler.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import {Dialog} from "quasar";
import ShowFieldInfoDialog from "@/components/dialogs/ShowFieldInfoDialog.vue";
import EditUIElementPropertiesBtn from "@/components/EditView/EditUIElementPropertiesBtn.vue";
import ListPresenter from "@/utils/common/ListPresenter.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import EditViewPerformer from "@/utils/presenters/EditViewPerformer.ts";
import ListViewPerformer from "@/utils/presenters/ListViewPerformer.ts";
import GUIActionPlaceholder = namaTypes.GUIActionPlaceholder;

const props = defineProps<{
  presenter: TPresenter,
  action: GUIActionPlaceholder
}>();

const {showFieldInfoActive, isUltra} = storeToRefs(useNamaFlagsStore());
const presenter = props.presenter;
const actionHandler = new ActionHandler(props.action, presenter.fetchMetadata(), presenter.entityType, getViewPerformer(presenter));

function getViewPerformer(presenter: TPresenter) {
  if (presenter instanceof EditPresenter)
    return new EditViewPerformer(presenter)
  else
    return new ListViewPerformer(presenter)
}

function showActionInfoDialog(e: MouseEvent) {
  if (!showFieldInfoActive.value)
    return;
  e.preventDefault()
  Dialog.create({
    component: ShowFieldInfoDialog,
    componentProps: {
      action: props.action,
      entityType: presenter.entityType
    }
  });
}
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-1">
    <EditUIElementPropertiesBtn :actionInfo="action" :entity-type="presenter.entityType"/>
    <a
      @contextmenu="showActionInfoDialog"
      :title="Translator.translateTitledId(presenter.entityType, props.action)"
      :data-action-id="action.id"
      class="hover:tw-bg-gray-200 active:tw-bg-gray-300 tw-gap-1 tw-flex tw-flex-col tw-items-center
            tw-p-2 tw-rounded-lg tw-cursor-pointer  dark:hover:tw-bg-gray-700 dark:active:tw-bg-gray-600"
      @click.stop="actionHandler.performAction();">
      <NamaIcon
        default-icon="nm-actions"
        :presenter="presenter" :block="action"
        class="tw-size-6 tw-text-[24px] ultra:tw-size-5 ultra:tw-text-[20px]"/>
      <span v-if="useNamaFlagsStore().showToolbarLabels && !isUltra"
            v-text="Translator.translateTitledId(presenter.entityType, props.action) || 'No Title Assigned'"
            class="tw-text-namaFontColor-light/70 dark:tw-text-white/70 tw-text-xs tw-select-none tw-capitalize tw-whitespace-nowrap"/>
    </a>
  </div>
</template>

